// extracted by mini-css-extract-plugin
export default {"dark":"collapsed-disabled-layout_dark__TLLO9","gradient":"collapsed-disabled-layout_gradient__aPrHZ","light":"collapsed-disabled-layout_light__e-Ipx"};